/**
 * @fileoverview Utilities for categorizing ended chat sessions.
 * Separates ended chats into abandoned (no agent) and resolved (had agent) categories.
 */

import { LivechatSessionType } from "@/store/modules/livechat/types";

/**
 * Splits ended chat sessions into abandoned and resolved categories.
 * Abandoned chats have no assigned agents. Resolved chats have at least one agent.
 *
 * @param {LivechatSessionType[]} endedChatSessions - Array of ended chat sessions
 * @returns {{abandonedChats: LivechatSessionType[], resolvedChats: LivechatSessionType[]}} Categorized chats
 *
 * @example
 * const { abandonedChats, resolvedChats } = splitAbandonedResolvedChats(endedChats);
 */
export function splitAbandonedResolvedChats(endedChatSessions: LivechatSessionType[]): {
  abandonedChats: LivechatSessionType[];
  resolvedChats: LivechatSessionType[];
} {
  const resolvedChats: LivechatSessionType[] = [];
  const abandonedChats: LivechatSessionType[] = [];
  endedChatSessions.forEach((chat) => {
    if (chat.agents && chat.agents.length > 0) {
      resolvedChats.push(chat);
    } else {
      abandonedChats.push(chat);
    }
  });

  return {
    abandonedChats,
    resolvedChats,
  };
}
